<template>
  <div>
    <vx-card>
      <vs-tabs alignment="fixed">
        <vs-tab label="N8n">
          <N8n :subjectPermission="subjectPermission" />
        </vs-tab>
        <vs-tab label="Rotinas Auto">
          <RoutinesAuto :subjectPermission="subjectPermission" />
        </vs-tab>
        <vs-tab label="Métodos de pagamento">
          <PaymentMethodConfig :subjectPermission="subjectPermission"/>
        </vs-tab>
        <vs-tab label="Regras">
          <AutoAnualRules :subjectPermission="subjectPermission" />
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>
<script>
import N8n from './n8n/N8n.vue';
import RoutinesAuto from './routines-auto/RoutinesAuto.vue';
import PaymentMethodConfig from "./payment-method-configs/PaymentMethodConfig.vue";
import AutoAnualRules from './rules/AutoAnualRules.vue';
export default {
  name: 'AutoAnual',
  components: { N8n, RoutinesAuto, PaymentMethodConfig, AutoAnualRules },
  data() {
    return {
      subjectPermission: 'Automóvel Anual',
    };
  },
};
</script>
<style></style>
